// extracted by mini-css-extract-plugin
export var brand = "_aa-9";
export var compact = "_aa-6";
export var extraSmall = "_aa-7";
export var icon = "_aa-0";
export var large = "_aa-4";
export var light = "_aa-1";
export var medium = "_aa-5";
export var outline = "_aa-b";
export var primaryDark = "_aa-a";
export var primaryLight = "_aa-8";
export var primaryModern = "_aa-c";
export var success = "_aa-2";
export var successSolid = "_aa-3";